import React, { useState } from 'react'
import { Tab, Item, Label, Select, Comment, Button } from 'semantic-ui-react'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/themes/airbnb.css'
import './activityItemsListPaneStyles.less'

const ActivityItemsListPane = ({
    loading,
    isFetching,
    listItems,
    onActivityListItemClick
}) => {

    const [tagFilter, setTagFilter] = useState<any>()
    const [dateFilter, setDateFilter] = useState<any>()
    
    let localItemsList = [...listItems]
    localItemsList.sort((item1, item2) => {
        if (item1.timestamp < item2.timestamp) {
            return 1
        }
        if (item1.timestamp > item2.timestamp) {
            return -1
        }
        if (item1.timestamp === item2.timestamp) {
            return 0
        }
        return 0
    })
    const [listToDisplay, setListToDisplay] = useState<any[]>(localItemsList)


    const convertToListItemElement = (listItem) => {
        return (
            <ListItemElement
                key={listItem._id}
                id={listItem._id}
                text={listItem.text}
                time={listItem.timestamp}
                status={listItem.status}
                onClick={() => {
                    onActivityListItemClick(listItem)
                }}
                // sourcePage={props.sourcePage}
                // deleteListItem={props.deleteListItem}
                // editListItem={props.editListItem}
                // copyListItem={props.copyListItem}
                // playableUrl={listItem.playableUrl}
            />
        )
    }

    const clearFilters = () => {
        setTagFilter('')
        setDateFilter('')
        setListToDisplay(localItemsList)
    }

    const changeListToDisplay = (tagFilterValue:any = undefined, timeFilterValue:any = undefined) => {
        console.log('Entered changeListToDisplay with args:', tagFilterValue, timeFilterValue)
        let newListToDisplay = [...localItemsList]
        if (tagFilterValue) {
            newListToDisplay = localItemsList.filter(item => {
                if (tagFilterValue === 'intend_attend') {
                    return item.status === 'intend_attend' || item.status === 'removed'
                }
                return item.status === tagFilterValue
            })
        }
        if (timeFilterValue) {
            console.log('Time filter linux time:', Date.parse(timeFilterValue))
            const timeFilterMilliseconds = Date.parse(timeFilterValue)
            newListToDisplay = newListToDisplay.filter(item => {
                return (
                    (item.timestamp > timeFilterMilliseconds) && 
                    (item.timestamp < timeFilterMilliseconds + 86400000 - 1)
                )
            })
            
        }

        if (!tagFilterValue && !timeFilterValue) {
            setListToDisplay(localItemsList)
        } else {
            setListToDisplay(newListToDisplay)
        }
    }

    return (
        <Tab.Pane loading={false} className="items-list-container">
            {listItems && listItems.length > 0
            ?
                <Comment.Group>
                    Filters:
                    <Flatpickr
                        className="date-filter"
                        value={dateFilter}
                        options={{ dateFormat: 'd.m.Y' }}
                        placeholder="Select Date"
                        onChange={(time:string) => setDateFilter(time)}
                        style={{margin: '1em'}}
                    />
                    <Select 
                        placeholder='Select tag' 
                        options={[
                            {
                                key: 'intend_attend',
                                value: 'intend_attend',
                                text: 'Intended to attend'
                            },
                            {
                                key: 'attended',
                                value: 'attended',
                                text: 'Attended'
                            }
                        ]}
                        onChange={(e, { value }) => {
                            console.log('Dropdown changed:', value)
                            setTagFilter(value)
                        }}
                        value={tagFilter}
                        style={{margin:'1em'}}
                    />
                    
                    <Button size='mini' primary onClick={() => changeListToDisplay(tagFilter, dateFilter)} >
                        Apply
                    </Button>
                    <Button size='mini' primary onClick={() => clearFilters()} className='meta_options_column'>
                        Clear
                    </Button>
                </Comment.Group>
            
            :   <p>No activities to display</p>
            }
            {listToDisplay && listToDisplay.length > 0
            ?
                <Item.Group relaxed>
                    {listToDisplay.map(convertToListItemElement)}
                </Item.Group>
            :   listItems && listItems.length > 0 ? <p style={{margin: '2em'}}>No activities to display</p> : ''
            }
        </Tab.Pane>
    )
}

const ListItemElement = ({
    key,
    id,
    text,
    time,
    status,
    onClick
}) => {
    return (
        <Item className="ListItem" onClick={onClick}>
            <Item.Content verticalAlign="middle">
                <Item.Description as="div">
                    {<div dangerouslySetInnerHTML={{ __html: text }}></div>}
                </Item.Description>

                {/* {props.playableUrl && (
                    <Item.Description>
                        <audio controls src={props.playableUrl}>
                            Your browser does not support the
                            <code>audio</code> element.
                        </audio>
                    </Item.Description>
                )} */}
                <Item.Meta className="list-item-time">{formatTime(time)}</Item.Meta>

                {/* <Item.Meta onClick={() => props.editListItem(props.id)} className="meta_options_column">
                    <Button>{'Edit'}</Button>
                </Item.Meta> */}

                {/* <Item.Meta className="meta_options_column" onClick={() => props.deleteListItem(props.id)}>
                    <Button>{'Delete'}</Button>
                </Item.Meta> */}
                {/* {!props.playableUrl && (
                    <Item.Meta
                        className="meta_options_column"
                        onClick={() => {
                            if (props.copyListItem) {
                                props.copyListItem(props.id)
                            }
                        }}
                    >
                        <Button>{'Copy'}</Button>
                    </Item.Meta>
                )} */}
                {/* <Item.Meta className="meta_options_column"> */}
                    {(status === 'intend_attend' || status === 'removed') &&
                        <Label color='yellow' horizontal className="meta_options_column">
                            Intended to attend
                        </Label>
                    }
                    {status === 'attended' &&
                        <Label color='green' horizontal className="meta_options_column">
                            Attended
                        </Label>
                    }
                {/* </Item.Meta> */}
            </Item.Content>
        </Item>
    )
}

const formatTime = (time) => {
    return `${new Date(time).toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
    })} 
    ${new Date(time).toLocaleTimeString('en-US')}`
}

export default ActivityItemsListPane